import type { Preset } from '@primeuix/themes/types';
import type { NoraBaseDesignTokens } from './base/index.d';

import accordion from '@primeuix/themes/nora/accordion';
import autocomplete from '@primeuix/themes/nora/autocomplete';
import avatar from '@primeuix/themes/nora/avatar';
import badge from '@primeuix/themes/nora/badge';
import base from '@primeuix/themes/nora/base';
import blockui from '@primeuix/themes/nora/blockui';
import breadcrumb from '@primeuix/themes/nora/breadcrumb';
import button from '@primeuix/themes/nora/button';
import card from '@primeuix/themes/nora/card';
import carousel from '@primeuix/themes/nora/carousel';
import cascadeselect from '@primeuix/themes/nora/cascadeselect';
import checkbox from '@primeuix/themes/nora/checkbox';
import chip from '@primeuix/themes/nora/chip';
import colorpicker from '@primeuix/themes/nora/colorpicker';
import confirmdialog from '@primeuix/themes/nora/confirmdialog';
import confirmpopup from '@primeuix/themes/nora/confirmpopup';
import contextmenu from '@primeuix/themes/nora/contextmenu';
import datatable from '@primeuix/themes/nora/datatable';
import dataview from '@primeuix/themes/nora/dataview';
import datepicker from '@primeuix/themes/nora/datepicker';
import dialog from '@primeuix/themes/nora/dialog';
import divider from '@primeuix/themes/nora/divider';
import dock from '@primeuix/themes/nora/dock';
import drawer from '@primeuix/themes/nora/drawer';
import editor from '@primeuix/themes/nora/editor';
import fieldset from '@primeuix/themes/nora/fieldset';
import fileupload from '@primeuix/themes/nora/fileupload';
import floatlabel from '@primeuix/themes/nora/floatlabel';
import galleria from '@primeuix/themes/nora/galleria';
import iconfield from '@primeuix/themes/nora/iconfield';
import iftalabel from '@primeuix/themes/nora/iftalabel';
import image from '@primeuix/themes/nora/image';
import imagecompare from '@primeuix/themes/nora/imagecompare';
import inlinemessage from '@primeuix/themes/nora/inlinemessage';
import inplace from '@primeuix/themes/nora/inplace';
import inputchips from '@primeuix/themes/nora/inputchips';
import inputgroup from '@primeuix/themes/nora/inputgroup';
import inputnumber from '@primeuix/themes/nora/inputnumber';
import inputotp from '@primeuix/themes/nora/inputotp';
import inputtext from '@primeuix/themes/nora/inputtext';
import knob from '@primeuix/themes/nora/knob';
import listbox from '@primeuix/themes/nora/listbox';
import megamenu from '@primeuix/themes/nora/megamenu';
import menu from '@primeuix/themes/nora/menu';
import menubar from '@primeuix/themes/nora/menubar';
import message from '@primeuix/themes/nora/message';
import metergroup from '@primeuix/themes/nora/metergroup';
import multiselect from '@primeuix/themes/nora/multiselect';
import orderlist from '@primeuix/themes/nora/orderlist';
import organizationchart from '@primeuix/themes/nora/organizationchart';
import overlaybadge from '@primeuix/themes/nora/overlaybadge';
import paginator from '@primeuix/themes/nora/paginator';
import panel from '@primeuix/themes/nora/panel';
import panelmenu from '@primeuix/themes/nora/panelmenu';
import password from '@primeuix/themes/nora/password';
import picklist from '@primeuix/themes/nora/picklist';
import popover from '@primeuix/themes/nora/popover';
import progressbar from '@primeuix/themes/nora/progressbar';
import progressspinner from '@primeuix/themes/nora/progressspinner';
import radiobutton from '@primeuix/themes/nora/radiobutton';
import rating from '@primeuix/themes/nora/rating';
import ripple from '@primeuix/themes/nora/ripple';
import scrollpanel from '@primeuix/themes/nora/scrollpanel';
import select from '@primeuix/themes/nora/select';
import selectbutton from '@primeuix/themes/nora/selectbutton';
import skeleton from '@primeuix/themes/nora/skeleton';
import slider from '@primeuix/themes/nora/slider';
import speeddial from '@primeuix/themes/nora/speeddial';
import splitbutton from '@primeuix/themes/nora/splitbutton';
import splitter from '@primeuix/themes/nora/splitter';
import stepper from '@primeuix/themes/nora/stepper';
import steps from '@primeuix/themes/nora/steps';
import tabmenu from '@primeuix/themes/nora/tabmenu';
import tabs from '@primeuix/themes/nora/tabs';
import tabview from '@primeuix/themes/nora/tabview';
import tag from '@primeuix/themes/nora/tag';
import terminal from '@primeuix/themes/nora/terminal';
import textarea from '@primeuix/themes/nora/textarea';
import tieredmenu from '@primeuix/themes/nora/tieredmenu';
import timeline from '@primeuix/themes/nora/timeline';
import toast from '@primeuix/themes/nora/toast';
import togglebutton from '@primeuix/themes/nora/togglebutton';
import toggleswitch from '@primeuix/themes/nora/toggleswitch';
import toolbar from '@primeuix/themes/nora/toolbar';
import tooltip from '@primeuix/themes/nora/tooltip';
import tree from '@primeuix/themes/nora/tree';
import treeselect from '@primeuix/themes/nora/treeselect';
import treetable from '@primeuix/themes/nora/treetable';
import virtualscroller from '@primeuix/themes/nora/virtualscroller';

export default {
    ...base,
    components: {
        accordion,
        autocomplete,
        avatar,
        badge,
        blockui,
        breadcrumb,
        button,
        datepicker,
        card,
        carousel,
        cascadeselect,
        checkbox,
        chip,
        colorpicker,
        confirmdialog,
        confirmpopup,
        contextmenu,
        dataview,
        datatable,
        dialog,
        divider,
        dock,
        drawer,
        editor,
        fieldset,
        fileupload,
        iftalabel,
        floatlabel,
        galleria,
        iconfield,
        image,
        imagecompare,
        inlinemessage,
        inplace,
        inputchips,
        inputgroup,
        inputnumber,
        inputotp,
        inputtext,
        knob,
        listbox,
        megamenu,
        menu,
        menubar,
        message,
        metergroup,
        multiselect,
        orderlist,
        organizationchart,
        overlaybadge,
        popover,
        paginator,
        password,
        panel,
        panelmenu,
        picklist,
        progressbar,
        progressspinner,
        radiobutton,
        rating,
        ripple,
        scrollpanel,
        select,
        selectbutton,
        skeleton,
        slider,
        speeddial,
        splitter,
        splitbutton,
        stepper,
        steps,
        tabmenu,
        tabs,
        tabview,
        textarea,
        tieredmenu,
        tag,
        terminal,
        timeline,
        togglebutton,
        toggleswitch,
        tree,
        treeselect,
        treetable,
        toast,
        toolbar,
        tooltip,
        virtualscroller
    }
} satisfies Preset<NoraBaseDesignTokens>;
